import React, { useState } from "react";
import { BillingType, fibiBillingData, PlanRank } from "./data";
import FibiBilingCard from "./FibiBilingCard";
import useGetPrice from "../../../../../../../hooks/useGetPrice";
import {
  useBusinessBillingDowngrade,
  useBusinessBillingUpgrade,
  useSubscriptionPayment,
} from "../../../../../../../hooks/business/useBilling";
import { SpinnerWrapper } from "../../../../../components/styles";
import Spinner from "../../../../../../../utils/Spinner";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import TerminateModal from "../../../../../components/TerminateModal";
import { isBusinessDataStore } from "../../../../../../../store/isBusinessData";
import { useGetBusinessProfile } from "../../../../../../../hooks/business/useAuth";
import Colors from "../../../../../../../styles/Colors";
// import { usePaystackPayment } from "react-paystack";
// import { PaystackProps } from "react-paystack/dist/types";
// import { useBusinessVerifyFibiPaystack } from "../../../../../../../hooks/utils/useUtils";

const FibiBilling = () => {
  // const { businessUserData } = useSnapshot(businessUserDataStore);
  const { isBusinessData } = useSnapshot(isBusinessDataStore);
  const {
    data: businessUserData,
    isLoading: businessDataLoading,
    refetch,
  } = useGetBusinessProfile(isBusinessData);
  // const initializePayment = usePaystackPayment({
  //   email: businessUserData?.businessInfo.email,
  //   publicKey: process.env.REACT_APP_PAYSTACK_API_KEY as string,
  // });
  const { isNigeria } = useGetPrice();
  // const { mutate: verifyMutate } = useBusinessVerifyFibiPaystack();
  const { mutate: submutate, isLoading: subLoading } = useSubscriptionPayment();
  const { mutate: upgradeMutate, isLoading: upgradeLoading } =
    useBusinessBillingUpgrade();
  const { mutate: downgradeMutate, isLoading: downgradeLoading } =
    useBusinessBillingDowngrade();
  const [upgradeOpen, setUpgradeOpen] = useState<BillingType>();
  const [downgradeOpen, setDowngradeOpen] = useState<BillingType>();

  const onUpgradeOpen = (second: BillingType) => {
    setUpgradeOpen(second);
  };

  const onUpgradeClose = () => {
    setUpgradeOpen(undefined);
  };

  const onDowngradeOpen = (second: BillingType) => {
    setDowngradeOpen(second);
  };

  const onDowngradeClose = () => {
    setDowngradeOpen(undefined);
  };

  const onUpgrade = () => {
    if (!upgradeOpen) return;

    const payload = {
      isNigeria,
      billingType: upgradeOpen,
    };

    upgradeMutate(payload, {
      onSuccess: () => {
        onUpgradeClose();
        refetch();
        toast.success("Upgrade Successful");
      },
    });
  };

  const onDowngrade = () => {
    if (!downgradeOpen) return;
    const payload = { email: [], isNigeria, billingType: downgradeOpen };

    downgradeMutate(payload, {
      onSuccess: () => {
        onDowngradeClose();
        refetch();
        toast.success("Downgrade Successful");
      },
    });
  };

  const onSubmit = (
    params: BillingType,
    // price: number,
    paystackPlan: string
  ) => {
    // if (isNigeria) {
    //   if (!businessUserData?.businessInfo.email) return;
    //   const config: Omit<PaystackProps, "publicKey"> = {
    //     email: businessUserData?.businessInfo.email,
    //     amount: price * 100,
    //     plan: paystackPlan,
    //   };
    //   initializePayment({
    //     config,
    //     onClose: () => {
    //       verifyMutate();
    //     },
    //   });
    // } else {
    const payload = {
      billingType: params,
      isNigeria: false,
    };

    submutate(payload, {
      onSuccess: (data) => {
        window.location.replace(data.data.url);
      },
    });
    // }
  };

  const onClick = (
    params: BillingType,
    // price: number,
    paystackPlan: string
  ) => {
    const isYearly = (plan: BillingType) =>
      plan.toLowerCase().includes("yearly");

    const checkGrade = () => {
      if (!businessUserData?.paymentInfo.subscriptionType) return;

      const currentPlan = businessUserData.paymentInfo.subscriptionType;
      const requestedPlan = params;

      const currentRank = PlanRank[currentPlan];
      const requestedRank = PlanRank[requestedPlan];

      // If any plan is not ranked, exit early
      if (!currentRank || !requestedRank) return;

      if (currentRank === requestedRank) {
        // Same plan level: check for monthly vs yearly differences.
        if (isYearly(currentPlan) && !isYearly(requestedPlan)) {
          // Downgrading from yearly to monthly
          onDowngradeOpen(requestedPlan);
        } else if (!isYearly(currentPlan) && isYearly(requestedPlan)) {
          // Upgrading from monthly to yearly
          onUpgradeOpen(requestedPlan);
        }
        // If both share the same period type, nothing to do.
        return;
      }

      // For different ranks, a higher rank is an upgrade.
      if (requestedRank > currentRank) {
        onUpgradeOpen(requestedPlan);
      } else {
        onDowngradeOpen(requestedPlan);
      }
    };
    businessUserData?.paymentInfo.subscriptionType
      ? checkGrade()
      : onSubmit(params, paystackPlan);
  };

  const masterLoading = subLoading || businessDataLoading;

  return (
    <>
      {masterLoading ? (
        <SpinnerWrapper>
          <Spinner size={40} />
        </SpinnerWrapper>
      ) : (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 ">
          {fibiBillingData().map((ev, index) => (
            <FibiBilingCard
              key={index}
              data={ev}
              onButtonClick={onClick}
              currentPlan={businessUserData?.paymentInfo.subscriptionType}
            />
          ))}
        </div>
      )}
      {downgradeOpen && (
        <TerminateModal
          title={`Downgrade Subscription`}
          subText={`Are you sure you want to downgrade your subscription?`}
          onClose={onDowngradeClose}
          onConfirm={onDowngrade}
          isLoading={downgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )}

      {upgradeOpen && (
        <TerminateModal
          title={`Upgrade Subscription`}
          subText={`Are you sure you want to upgrade your subscription?`}
          onClose={onUpgradeClose}
          onConfirm={onUpgrade}
          isLoading={upgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )}
    </>
  );
};

export default FibiBilling;
